import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ScrollPanel, ScrollPanelModule } from 'primeng/scrollpanel';
import { FeedItemDto, FeedItemsResponseDto } from 'src/app/shared/dtos/feed-items.dto';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { AnalyticsEventName } from 'src/app/core/enums/analytics.enum';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-whats-new-modal',
  imports: [
    ScrollPanelModule,
    TranslocoPipe
  ],
  templateUrl: './whats-new-modal.html',
  styleUrl: './whats-new-modal.scss'
})
export class WhatsNewModal implements OnInit {
  private readonly analyticsService = inject(AnalyticsService);

  @Input({required: true}) allFeedItems: FeedItemsResponseDto;
  @Input() currentFeedTitle: string;

  @ViewChild(ScrollPanel) scrollPanel: ScrollPanel;

  protected readonly dialogConfig: DynamicDialogConfig;
  protected feedIndex = 0;
  protected currentFeedItem: FeedItemDto;

  constructor(public config: DynamicDialogConfig) { // eslint-disable-line
    this.dialogConfig = config;
  }

  ngOnInit(): void {
    this.feedIndex = this.allFeedItems.items.findIndex(item => item.title === this.currentFeedTitle);
    this.currentFeedItem = this.allFeedItems.items[this.feedIndex];
  }

  protected next(): void {
    if (this.feedIndex === this.allFeedItems.item_count - 1) return;
    this.feedIndex += 1;
    this.currentFeedItem = this.allFeedItems.items[this.feedIndex];
    this.dialogConfig.header = this.currentFeedItem.title;
    this.scrollPanel.refresh();
    this.trackEvent();
  }

  protected previous(): void {
    if (this.feedIndex === 0) return;
    this.feedIndex -= 1;
    this.currentFeedItem = this.allFeedItems.items[this.feedIndex];
    this.dialogConfig.header = this.currentFeedItem.title;
    this.scrollPanel.refresh();
    this.trackEvent();
  }

  protected trackEvent(): void {
    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      screenName: 'whats_new_item',
      itemId: this.currentFeedItem.title,
      itemName: this.currentFeedItem.title,
    });
  }
}
